import angular from 'angular';
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';

let inject = [
  '$scope',
  'TemplateDetailService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  '$timeout',
  'Pagination',
  'SessionService',
  '$window',
  'ngAuthSettings',
  '$stateParams'
];

class TemplateDetailController {
  constructor($scope,
              TemplateDetailService,
              $state,
              $rootScope,
              SharedService,
              $uibModal,
              $timeout,
              Pagination,
              SessionService,
              $window,
              ngAuthSettings,
              $stateParams) {
    this.$state = $state;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.ngAuthSettings = ngAuthSettings;
    this.$uibModal = $uibModal;
    this.TemplateDetailService = TemplateDetailService;
    this.Pagination = Pagination;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
    this.$window = $window;
    this.loadingTemplate = false;
  }

  $onInit() {
    this.getTemplate();
  }

  getTemplate() {
    this.loadingTemplate = true;
    let globals = this.shCtrl.globals;

    let userId = '';
    try {
      userId = globals.currentUser.userId;
    } catch (e) {
    }

    let sellerId = '';
    try {
      sellerId = globals.currentUser.sellerId;
    } catch (e) {
    }

    this.TemplateDetailService.getUserCartTemplate({
      'id': this.$stateParams.templateId,
      'userId': userId,
      'sellerId': sellerId
    }).then(response => {
      this.loadingTemplate = false;

      if (!response.error) {
        this.template = response.data.template;
      } else {
        // TODO
      }
    }).catch(reason => {
      this.loadingTemplate = false;
    });
  }

  messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: options.size,
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
      if (callAcept) {
        callback();
      }
    }).catch(reason => {
      if (callCancel) {
        callbackCancel();
      }
    });
  }
}

TemplateDetailController.$inject = inject;

export default TemplateDetailController;




// WEBPACK FOOTER //
// ./www/components/templates/template-detail/template-detail.controller.js